import { IMapState } from '../../types';

export function selectMinZoom(state: IMapState): number {
  return state.map.infrastructure.config.minZoom;
}
